import { create } from 'zustand';

const useStore = create((set) => ({
  scannedQr: null,
  setScannedQr: (qr) => set({ scannedQr: qr }),
  clearScannedQr: () => set({ scannedQr: null }),
  
  // Глобальная ошибка API
  apiError: null,
  setApiError: (error) => set({ apiError: error }),
  clearApiError: () => set({ apiError: null }),
  
  // Информация о подключении
  connectionInfo: null,
  setConnectionInfo: (info) => set({ connectionInfo: info }),
  
  cart: [],
  addToCart: (product, qty) => set((state) => {
    const existing = state.cart.find(item => item.product_id === product.id);
    if (existing) {
      return {
        cart: state.cart.map(item =>
          item.product_id === product.id
            ? { ...item, qty: item.qty + qty }
            : item
        )
      };
    }
    return {
      cart: [...state.cart, { product_id: product.id, product, qty }]
    };
  }),
  removeFromCart: (productId) => set((state) => ({
    cart: state.cart.filter(item => item.product_id !== productId)
  })),
  clearCart: () => set({ cart: [] }),
  updateCartItemQty: (productId, qty) => set((state) => ({
    cart: state.cart.map(item =>
      item.product_id === productId ? { ...item, qty } : item
    )
  })),
}));

export default useStore;

